// Generated by purs version 0.15.0
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Map_Serialized from "../Data.Map.Serialized/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Menu_V2_Types_FulfillmentMethod from "../Restaumatic.Menu.V2.Types.FulfillmentMethod/index.js";
import * as Restaumatic_Menu_V2_Types_OrderOrigin from "../Restaumatic.Menu.V2.Types.OrderOrigin/index.js";
import * as Restaumatic_Menu_V2_Types_PaymentMethod from "../Restaumatic.Menu.V2.Types.PaymentMethod/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var OriginChoice = /* #__PURE__ */ (function () {
    function OriginChoice(value0) {
        this.value0 = value0;
    };
    OriginChoice.create = function (value0) {
        return new OriginChoice(value0);
    };
    return OriginChoice;
})();
var FulfillmentMethodChoice = /* #__PURE__ */ (function () {
    function FulfillmentMethodChoice(value0) {
        this.value0 = value0;
    };
    FulfillmentMethodChoice.create = function (value0) {
        return new FulfillmentMethodChoice(value0);
    };
    return FulfillmentMethodChoice;
})();
var PaymentMethodChoice = /* #__PURE__ */ (function () {
    function PaymentMethodChoice(value0) {
        this.value0 = value0;
    };
    PaymentMethodChoice.create = function (value0) {
        return new PaymentMethodChoice(value0);
    };
    return PaymentMethodChoice;
})();
var IsDividedChoice = /* #__PURE__ */ (function () {
    function IsDividedChoice(value0) {
        this.value0 = value0;
    };
    IsDividedChoice.create = function (value0) {
        return new IsDividedChoice(value0);
    };
    return IsDividedChoice;
})();
var ScheduleChoice = /* #__PURE__ */ (function () {
    function ScheduleChoice(value0) {
        this.value0 = value0;
    };
    ScheduleChoice.create = function (value0) {
        return new ScheduleChoice(value0);
    };
    return ScheduleChoice;
})();
var eqInternalParameterChoice = {
    eq: function (x) {
        return function (y) {
            if (x instanceof OriginChoice && y instanceof OriginChoice) {
                return Data_Eq.eq(Restaumatic_Menu_V2_Types_OrderOrigin.eqOrderOrigin)(x.value0)(y.value0);
            };
            if (x instanceof FulfillmentMethodChoice && y instanceof FulfillmentMethodChoice) {
                return Data_Eq.eq(Restaumatic_Menu_V2_Types_FulfillmentMethod.eqFulfillmentMethod)(x.value0)(y.value0);
            };
            if (x instanceof PaymentMethodChoice && y instanceof PaymentMethodChoice) {
                return Data_Eq.eq(Restaumatic_Menu_V2_Types_PaymentMethod.eqPaymentMethod)(x.value0)(y.value0);
            };
            if (x instanceof IsDividedChoice && y instanceof IsDividedChoice) {
                return x.value0 === y.value0;
            };
            if (x instanceof ScheduleChoice && y instanceof ScheduleChoice) {
                return x.value0 === y.value0;
            };
            return false;
        };
    }
};
var ordInternalParameterChoic = {
    compare: function (x) {
        return function (y) {
            if (x instanceof OriginChoice && y instanceof OriginChoice) {
                return Data_Ord.compare(Restaumatic_Menu_V2_Types_OrderOrigin.ordOrderOrigin)(x.value0)(y.value0);
            };
            if (x instanceof OriginChoice) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof OriginChoice) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof FulfillmentMethodChoice && y instanceof FulfillmentMethodChoice) {
                return Data_Ord.compare(Restaumatic_Menu_V2_Types_FulfillmentMethod.ordFulfillmentMethod)(x.value0)(y.value0);
            };
            if (x instanceof FulfillmentMethodChoice) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof FulfillmentMethodChoice) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof PaymentMethodChoice && y instanceof PaymentMethodChoice) {
                return Data_Ord.compare(Restaumatic_Menu_V2_Types_PaymentMethod.ordPaymentMethod)(x.value0)(y.value0);
            };
            if (x instanceof PaymentMethodChoice) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof PaymentMethodChoice) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof IsDividedChoice && y instanceof IsDividedChoice) {
                return Data_Ord.compare(Data_Ord.ordBoolean)(x.value0)(y.value0);
            };
            if (x instanceof IsDividedChoice) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof IsDividedChoice) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ScheduleChoice && y instanceof ScheduleChoice) {
                return Data_Ord.compare(Data_Ord.ordBoolean)(x.value0)(y.value0);
            };
            throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.InternalParameterChoiceId (line 26, column 1 - line 26, column 46): " + [ x.constructor.name, y.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqInternalParameterChoice;
    }
};
var genericInternalParameterChoiceId = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new OriginChoice(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new FulfillmentMethodChoice(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new PaymentMethodChoice(x.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return new IsDividedChoice(x.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inr))) {
            return new ScheduleChoice(x.value0.value0.value0.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.InternalParameterChoiceId (line 16, column 1 - line 16, column 105): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof OriginChoice) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof FulfillmentMethodChoice) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof PaymentMethodChoice) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
        };
        if (x instanceof IsDividedChoice) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))));
        };
        if (x instanceof ScheduleChoice) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0))));
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.InternalParameterChoiceId (line 16, column 1 - line 16, column 105): " + [ x.constructor.name ]);
    }
};
var showInternalParameterChoiceId = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericInternalParameterChoiceId)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Restaumatic_Menu_V2_Types_OrderOrigin.showOrderOrigin))({
        reflectSymbol: function () {
            return "OriginChoice";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Restaumatic_Menu_V2_Types_FulfillmentMethod.showFulfillmentMethod))({
        reflectSymbol: function () {
            return "FulfillmentMethodChoice";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Restaumatic_Menu_V2_Types_PaymentMethod.showPaymentMethod))({
        reflectSymbol: function () {
            return "PaymentMethodChoice";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showBoolean))({
        reflectSymbol: function () {
            return "IsDividedChoice";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showBoolean))({
        reflectSymbol: function () {
            return "ScheduleChoice";
        }
    }))))))
};
var unscrambleDecodeInternalParameterChoiceId = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericInternalParameterChoiceId)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "OriginChoice";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(Restaumatic_Menu_V2_Types_OrderOrigin.unscrambleDecodeOrderOrigin)))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "FulfillmentMethodChoice";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(Restaumatic_Menu_V2_Types_FulfillmentMethod.unscrambleDecodeFulfillmentMethod)))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "PaymentMethodChoice";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(Restaumatic_Menu_V2_Types_PaymentMethod.unscrambleDecodePaymentMethod)))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "IsDividedChoice";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(Unscramble.decodeBoolean1)))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "ScheduleChoice";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(Unscramble.decodeBoolean1))))))))(Unscramble_Generic.defaultOptions)
};
var ufromJSONKeyInternalParameterChoiceId = {
    fromJSONKey: /* #__PURE__ */ Unscramble.defaultFromJSONKeyValue(unscrambleDecodeInternalParameterChoiceId)
};
var encodeInternalParameterChoiceId = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericInternalParameterChoiceId)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "OriginChoice";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_V2_Types_OrderOrigin.encodeOrderOrigin))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "FulfillmentMethodChoice";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_V2_Types_FulfillmentMethod.encodeFulfillmentMethod))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "PaymentMethodChoice";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_V2_Types_PaymentMethod.encodePaymentMethod))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "IsDividedChoice";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "ScheduleChoice";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode))))))))
};
var decodeInternalParameterChoiceId = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericInternalParameterChoiceId)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "OriginChoice";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_V2_Types_OrderOrigin.decodeOrderOrigin)))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "FulfillmentMethodChoice";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_V2_Types_FulfillmentMethod.decodeFulfillmentMethod)))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "PaymentMethodChoice";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_V2_Types_PaymentMethod.decodePaymentMethod)))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "IsDividedChoice";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode)))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "ScheduleChoice";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode)))(Foreign_Generic_Class.genericCountArgsArgument))))))
};
var asJSONKeyInternalParameterChoiceId = /* #__PURE__ */ (function () {
    return {
        asJSONKey: new Data_Map_Serialized.AsJSONKeyValue(Foreign_Generic_Class.encode(encodeInternalParameterChoiceId), Foreign_Generic_Class.decode(decodeInternalParameterChoiceId))
    };
})();
export {
    OriginChoice,
    FulfillmentMethodChoice,
    PaymentMethodChoice,
    IsDividedChoice,
    ScheduleChoice,
    genericInternalParameterChoiceId,
    eqInternalParameterChoice,
    showInternalParameterChoiceId,
    asJSONKeyInternalParameterChoiceId,
    ufromJSONKeyInternalParameterChoiceId,
    ordInternalParameterChoic,
    encodeInternalParameterChoiceId,
    decodeInternalParameterChoiceId,
    unscrambleDecodeInternalParameterChoiceId
};
//# sourceMappingURL=index.js.map
